export * from "-!../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./coupon.vue?vue&type=template&id=562c6438"


//////////////////
// WEBPACK FOOTER
// ./src/components/clients/client/settings/bonuses/coupon.vue?vue&type=template&id=562c6438
// module id = jJ3y
// module chunks = 0